module.exports = __webpack_public_path__ + "packs/media/images/home_8-57eb0b738f5df805a07ec08692ee4426.jpg";